export const TOOLS_GA_EVENT_LABEL = 'Tools';

export const INSTALL_BUTTON_CLICKS = 'install_button_clicks';
export const INSTALL_BUTTON_PWA_INSTALL = 'install_button_pwa_install';
export const INSTALL_BUTTON_PACKAGE_DOWNLOAD = 'install_button_package_download';
